import { EventType, useGetEventPhotoByEventHandleQuery } from '@graphql/generated';

type UseEventPhoto = Maybe<{ id?: string; url?: string }>;
/**
 * To fetch the best photo URL for a given event handle.
 *
 * @param {string} [eventHandle] - The unique event handle.
 * @param {boolean} [shouldSkipCall] - Whether to skip fetching the photo.
 */
export const useEventPhoto = (eventHandle?: string, shouldSkipCall?: boolean) => {
  const { data, ...rest } = useGetEventPhotoByEventHandleQuery({
    variables: { website: eventHandle! },
    skip: !eventHandle || shouldSkipCall,
    batchMode: 'fast',
  });

  const eventPhoto: UseEventPhoto = extractEventPhoto(data?.eventByName);

  return { eventPhoto, ...rest };
};

interface SupportedHeaderPhotoLayoutSchema {
  photos?: ReadonlyArray<{ id: string; url: string }>;
}

type Event = {
  photo?: { id: string; url: string } | null | undefined;
  photoV2Url?: string | null;
  info: {
    eventType: EventType;
  };
  eventDesign?: Maybe<{
    activeWebsiteHeaderPresentationLayout?: Maybe<{
      dataJSON?: SupportedHeaderPhotoLayoutSchema;
    }>;
  }>;
};

const extractEventPhoto = <T extends Event>(event?: Maybe<T>): { id: string | undefined; url: string | undefined } | undefined => {
  const eventPhoto = event?.photo;
  if (event?.info.eventType === EventType.general && event?.photoV2Url) {
    return { id: undefined, url: event.photoV2Url };
  }
  if (eventPhoto) {
    return { id: eventPhoto.id, url: eventPhoto.url };
  }
  const eventDesignPhoto = (event?.eventDesign?.activeWebsiteHeaderPresentationLayout?.dataJSON as SupportedHeaderPhotoLayoutSchema)?.photos?.[0];
  if (eventDesignPhoto) {
    return { id: eventDesignPhoto.id, url: eventDesignPhoto.url };
  }
  return;
};
